import fetch from '@/utils/fetch';
import moment from 'moment';

const toThousands = (num) => {
  let str;
  switch (num.length % 3) {
    case 1:
      str = `00${num}`;
      break;
    case 2:
      str = `0${num}`;
      break;
    default:
      str += `${num}`;
  }
  return str.match(/\d{3}/g).join(',').replace(/^0+/, '');
};
const formatMoney = (arg) => {
  if (arg - 0 === 0) {
    return arg;
  }
  const part = `${arg}`.split('.');
  if (part.length > 1) {
    if (toThousands(part[0]) === '') {
      return `0.${part[1]}`;
    }
    return `${toThousands(part[0])}.${part[1]}`;
  }
  return `${toThousands(part[0])}`;
};

const model = {
  state: {
    lineIndexes: [
      { title: '访问人数', value: 'visit_uv', color: '#9A4B00', checked: true },
      { title: '下单人数', value: 'order_person', color: '#F2637B', checked: false },
      { title: '下单笔数', value: 'order_count', color: '#FBD437', checked: false },
      { title: '下单金额(元)', value: 'order_price', color: '#36CBCB', checked: false },
      { title: '付款人数', value: 'pay_person', color: '#3AA1FF', checked: false },
      { title: '付款单数', value: 'pay_count', color: '#975FE5', checked: false },
      { title: '付款金额(元)', value: 'pay_price', color: '#81AFF1', checked: true },
      { title: '客单价(元)', value: 'per_person', color: '#ABAC59', checked: true },
    ], // 折线图中指标集
    date: [moment().add(-7, 'days').startOf('day'), moment().add(-1, 'days').startOf('day')], // 默认前一周
    analyticsSource: [],
    tableLoading: true,
    totalData: {
      order_person_total: 0,
      order_count_total: 0,
      order_price_total: 0,
      pay_person_total: 0,
      pay_count_total: 0,
      pay_price_total: 0,
      per_person_total: 0,
      visit_uv_total: 0,
      change_pay_person_total: 0,
      change_pay_count_total: 0,
      change_pay_price_total: 0,
    },
    // 子门店列表
    subShops: [],
    // 所属子门店
    belongShop: 0,
    realTimeBelongShop: 0,
    realData: {},
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { dataTrade }, getState }) => ({
    setSwitch(value) {
      dataTrade.setState({ lineIndexes: value });
    },
    async exportTable(args) {
      const { shop_id, shopType } = getState().basic;
      const { belongShop } = getState().dataTrade;
      const params = {
        ...args,
        shop_id,
        sub_shop_id: belongShop,
        sub_status: shopType === 'main' ? 1 : 0,
      };
      const data = await fetch('/trade/deal/dealexport', { type: 'POST', params });
      return data;
    },
    setDate(value) {
      dataTrade.setState({ date: value });
    },
    async queryAnalytics(args) {
      const { shop_id, shopType } = getState().basic;
      const { belongShop } = getState().dataTrade;
      const params = {
        ...args,
        shop_id,
        sub_shop_id: belongShop,
        sub_status: shopType === 'main' ? 1 : 0,
      };
      dataTrade.setState({ tableLoading: true });
      const data = await fetch('/trade/deal/analytics', { params });
      dataTrade.setState({ tableLoading: false });
      if (Object.keys(data).length > 0) {
        let i = 0;
        data.deal_data = data.deal_data || [];
        data.order_price_total = formatMoney((data.order_price_total / 100).toFixed(2));
        data.pay_price_total = formatMoney((data.pay_price_total / 100).toFixed(2));
        data.per_person_total = formatMoney((data.per_person_total / 100).toFixed(2));
        data.order_count_total = formatMoney(data.order_count_total);
        data.order_person_total = formatMoney(data.order_person_total);
        data.pay_count_total = formatMoney(data.pay_count_total);
        data.pay_person_total = formatMoney(data.pay_person_total);
        data.visit_uv_total = formatMoney(data.visit_uv_total);

        while (i < data.deal_data.length) {
          data.deal_data[i].order_price = (data.deal_data[i].order_price / 100).toFixed(2);
          data.deal_data[i].pay_price = (data.deal_data[i].pay_price / 100).toFixed(2);
          data.deal_data[i].per_person = (data.deal_data[i].per_person / 100).toFixed(2);
          data.deal_data[i].change_pay_price = (data.deal_data[i].change_pay_price / 100).toFixed(
            2,
          );
          i += 1;
        }
        dataTrade.setState({
          analyticsSource: data && data.deal_data ? data.deal_data : [],
          totalData: data ? { ...data } : {},
        });
      }
    },
    setBelongShop(val) {
      dataTrade.setState({ belongShop: `${val}` });
    },
    setTimeBelongShop(val) {
      dataTrade.setState({ realTimeBelongShop: `${val}` });
    },
    async getSubShops() {
      const { shop_id } = getState().basic;
      const result = await fetch('/merchant/shop/subshoplist', {
        params: { shop_id, cur_page: 0, per_page: 0 },
      });
      dataTrade.setState({ subShops: result ? result.sub_shop_list : [] });
    },
    async realTimeData(val = getState().dataTrade.belongShop) {
      const { shop_id } = getState().basic;
      const result = await fetch('/trade/deal/realtimedata', {
        params: { shop_id, sub_shop_id: `${val}` },
      });
      dataTrade.setState({ realData: result });
    },
  }),
};

export default model;
